import { render } from "./PropertyDetailCard.vue?vue&type=template&id=f30157e0&scoped=true"
import script from "./PropertyDetailCard.vue?vue&type=script&lang=js"
export * from "./PropertyDetailCard.vue?vue&type=script&lang=js"

import "./PropertyDetailCard.vue?vue&type=style&index=0&id=f30157e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f30157e0"]])

export default __exports__